import { baseClient } from '@merchant-clients/common';

import { ShopModel } from './shop.model';

const apiUrl = '/api/shops';

export const shopClient = {
  get(id: string): Promise<ShopModel> {
    return baseClient.get(`${apiUrl}/${id}`);
  },

  setActive(id: string): Promise<void> {
    return baseClient.body<undefined, void>({
      body: undefined,
      method: 'POST',
      url: `${apiUrl}/${id}/actions/set-active`,
    });
  },

  setInactive(id: string): Promise<void> {
    return baseClient.body<undefined, void>({
      body: undefined,
      method: 'POST',
      url: `${apiUrl}/${id}/actions/set-inactive`,
    });
  },
};
